import { getActiveState } from '../utils';

function getInboxActiveTrackLabel(state) {
  return getActiveState(state.lead.inbox.state).trackLabel;
}

function getInboxDataState(state) {
  return state.lead.inbox;
}

function getInboxUnReadState(state) {
  return state.lead.inbox.unRead;
}

function getInboxStatus(state) {
  return state.lead.inbox.status;
}

export { getInboxDataState, getInboxUnReadState, getInboxActiveTrackLabel, getInboxStatus };
